<template>
  <v-app
    id="login"
    class="primary"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg4
          >
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <img
                    src="/static/SW-Logo.png"
                    alt="Sunward Portal"
                    width="120"
                    height="120"
                  >
                  <h1 class="flex my-4 primary--text">SW PORTAL</h1>
                </div>
                <v-form>
                  <v-text-field
                    append-icon="person"
                    name="login"
                    label="Login"
                    type="text"
                    v-model="model.loginId"
                  ></v-text-field>
                  <v-text-field
                    autocomplete="current-password"
                    append-icon="lock"
                    name="password"
                    label="Password"
                    id="password"
                    type="password"
                    v-model="model.loginPassword"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <!-- <v-btn icon>
                  <v-icon color="blue">fa fa-facebook-square fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="red">fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn
                  block
                  color="primary"
                  @click="login"
                  v-hotkey="loginKey"
                  :loading="loading"
                >Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar
          :top="y === 'top'"
          :timeout="timeout"
          v-model="snackbar"
        >
          {{ snackbarMessage }}
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { authenticate, testapiToken } from '@/api/login';
import { AUTH_REQUEST } from './../store/actions/auth'
import {
  setToken, getToken
} from '@/util/auth'

export default {
  data: () => ({
    loading: false,
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    token: '',
    values: [],
    model: {
      loginId: 'crt',
      loginPassword: '1234'
    }
  }),
  computed: {

    loginKey () {

      return {
        // bind to hotkey 
        'enter': this.login
      }
    },

  },
  methods: {
    login () {
      this.loading = true;
      this.$store.dispatch(AUTH_REQUEST, this.model).then(() => {
        console.log(this.model);
        this.loading = false;
        // if (this.model.userId > 0) {

        window.getApp.$emit('APP_LOGIN_SUCCESS');
        // }
        // else {
        //   window.getApp.$emit('APP_API_ERROR', 'Incorrect username or password entered!.')
        // }
        // setTimeout(() => {
        //   this.$router.push('/dashboard');
        // }, 1000);
      }).catch(error => {

        this.loading = false;
        window.getApp.$emit('APP_API_ERROR', 'Login failed to due internal server error!.');


      });
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue